import { useConfig } from '@/composables/config'

export const CAMPAIGN_IDS = {
    FOOTER: 'footer',
    UNDER_GAME_ICON: 'under_game_icon',
    GAME_DESCRIPTION: 'game_description',
    PLAY_ON_APP_PROMO_BANNER: 'play_on_app_promo_banner',
    ANDROID_SMART_BANNER: 'android_smart_banner',
}

export function useGoToApp(campaignId: string) {
    const { VUE_APP_NATIVE_APP_ADJUST_URL } = useConfig()

    function goToApp() {
        let url = VUE_APP_NATIVE_APP_ADJUST_URL.replace('%PATH%', window.location.pathname)
        url = `${url}&adj_campaign=${campaignId}`
        window.open(url, '_blank')
    }

    return { goToApp }
}
